{
  "file": {
    "byte": "ottetto",
    "bytes": "ottetti",
    "kB": "kb",
    "MB": "MB",
    "GB": "GB",
    "TB": "TB"
  }
}
